import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GET_COMPETITION, TAB_ENTRY_UPLOAD, GET_INSTITUTIONS } from '../../enums';
import { get } from 'lodash';
import { CategoryButton } from './categoryButton';
import { setCompetitionTab } from '../../Navigation/currentTab';
import { setSelectedCategory } from '../reducers/entryState';
import { connect } from 'react-redux';
import { setCompetitionCategories } from '../reducers/competitionCategories';
import { getLabel } from '../../Language/labels';
import { TransitionWrapper } from '../../Helpers/transitionWrapper';
import { setCompetitionDetail } from '../reducers/competitionDetail';
import { sortBy } from 'lodash';
import { setInstitutions } from '../reducers/institurions';
import { setGenreLookup } from '../reducers/genreLookup';


function isBeforeUTC(serverDate) {
  // Convert the server date to a JavaScript Date object
  const serverUTCDate = new Date(serverDate);

  // Get the current date and time in the browser's local time zone

  const browserUTCDate = new Date();

  // Compare the dates
  if (serverUTCDate.getTime() > browserUTCDate.getTime()) {
    //server date is later than broswer date so isBefore is true
    return true;
  } else if (serverUTCDate.getTime() < browserUTCDate.getTime()) {
    //server date is in the past so not before
    return false;
  } else {
    //dates are the same
    return false;
  }
}

const CategorySelection = ({ dispatch, competitionCategories, loginState }) => {

  const [noCategories, setNoCategories] = useState(false);
  const { token } = loginState;

  useEffect(() => {
    const getCompetition = async () => {
      let result = await axios.get(GET_COMPETITION, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).catch(({ message, response }) => {
        setNoCategories(true);
        console.log(message, response);
      });

      //check the competition end date if there is one
      const competitionEndDate = get(result, 'data.data.end.date', '');
      //const competitionStartDate = get(result, 'data.data.start.date', '');
      let isCompetitionOpen = true;
      if (!isNaN(new Date(competitionEndDate).getTime())) {
        //check DateTime.Now is before competition date
        isCompetitionOpen = isBeforeUTC(competitionEndDate);
      }


      //setCompetition(result.data.data);
      if (get(result, 'data.data.genres.data', []).length > 0 && isCompetitionOpen) {
        const { data: { data: { genres: { data } } } } = result;
        const { data: { data: { institution_required, name, type, start, end, autoentries } } } = result;

        let categories = [];
        let genreData = []; // this will be a genreId-institution_required map that we can use at the category level to decide institution_required === true

        for (let index = 0; index < data.length; index++) {
          const genre = data[index];

          for (let i = 0; i < genre.categories.data.length; i++) {
            categories.push(genre.categories.data[i]);
          }

          genreData.push({ genreId: genre.id, institution_required: genre.institution_required });
        }

        // institution_required can appear at all levels now so get the institutions
        // every time
        let institutions = await axios.get(GET_INSTITUTIONS).catch((error) => {
          console.log(error);
        });

        if (institutions) {
          const { data } = institutions;
          let institutionsList = [{ value: 0, label: 'Other' }];
          for (let index = 0; index < Object.keys(data).length; index++) {
            const id = Object.keys(data)[index];
            // value": "message",
            // value": "code",
            // value": "debug",
            const garbageData = ['version', 'message', 'code', 'debug'];
            if (!garbageData.includes(id)) { //some random data managed to get into the list so screen that out
              institutionsList.push({
                value: id,
                label: data[id].replace('&amp;', '&')
              })
            }
          }
          dispatch(setInstitutions(sortBy(institutionsList, ['label'])));
        }


        dispatch(setCompetitionCategories(categories));
        dispatch(setCompetitionDetail({ institution_required, name, type, start, end, autoentries }));
        dispatch(setGenreLookup(genreData));
      } else {
        setNoCategories(true);
      }
    }
    if (competitionCategories.length === 0) {
      getCompetition();
    }
  }, [dispatch, competitionCategories.length, token])

  const selectCategory = (category) => {
    dispatch(setCompetitionTab(TAB_ENTRY_UPLOAD));
    dispatch(setSelectedCategory(category));
  }

  return (
    <TransitionWrapper>
      <h1 className='screen-title'>{getLabel('categorySelectTitle')}</h1>
      <div className='categories-container'>
        {competitionCategories.length > 0 && competitionCategories.map(obj => <CategoryButton category={obj} key={obj.id} onSelect={selectCategory} />)}
        {noCategories && <div className='no-categories-error'>
          <h1>{getLabel('noCategoriesFound')}</h1></div>}
      </div>
    </TransitionWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    competitionCategories: state.competitionCategories,
    loginState: state.loginState,
  }
}

export default connect(mapStateToProps)(CategorySelection)